import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { addActor, selectActors, selectSelectedActorId } from "../../app/slices/TrainingSlice";
import ActorCard from "./ActorCard";
import "./ActorPresetList.css";
import { ShortCuts } from "../../hooks/UseShortcutsHook";
import useShortcut from "../../hooks/UseShortcutsHook";
import { useDispatch } from "react-redux";
import {
  Actor,
} from "../../models/Actor";
import { ActorHelper } from "./ActorHelper";
import { matchesPresetSearch } from "../editor_columns/PresetColumnHeader";

export default function ActorPresetList({ search = "" }: { search?: string }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const actors = useSelector(selectActors);
  const selectedActorId = useSelector(selectSelectedActorId);

  useShortcut(ShortCuts.Copy, () => {
    navigator.clipboard.writeText(JSON.stringify(actors.find((actor) => selectedActorId === actor.id)));
  });

  useShortcut(ShortCuts.Paste, async () => {
    const text = await navigator.clipboard.readText();

    //Check if string is parseable JSON
    try {
      var pastedActor = JSON.parse(text);
    }
    catch (error) {
      console.log('Not in JSON format');
      return;
    }

    // Check if the pastedActor is of the expected type
    if (!isValidActor(pastedActor)) {
      console.log('Invalid actor format');
      return;
    }

    if (pastedActor.id === "player") {
      pastedActor = {
        ...ActorHelper.GetNewRandomActor(actors),
        id: uuidv4(),
      };
    }
    else {
      pastedActor.id = uuidv4();
    }

    dispatch(addActor(pastedActor));
  });


  const visibleActors = actors.filter((actor) => matchesPresetSearch(actor.workingName, search));

  const cards = visibleActors.map((actor) => (
    <ActorCard key={actor.id} actor={actor} isSelected={actor.id === selectedActorId} />
  ));

  return (
    <div className="px-[8px] pt-[4px] pb-[4px] flex flex-col gap-y-[2px] max-h-[100%] overflow-y-auto pit-creator-scrollbar">
      {cards}
      {visibleActors.length === 0 && actors.length > 0 && (
        <div className="px-[8px] py-[8px] text-[13px] italic text-creator-text-sub" data-testid="actor-list-no-matches">
          {t("preset_lists.no_matches")}
        </div>
      )}
    </div>
  );
}

function isValidActor(actor: Actor): Boolean {
  return actor &&
    typeof actor.id === 'string' &&
    typeof actor.workingName === 'string';
}
